const PATCH_NOTES = [
  {
    title: `Version ${process.env.VUE_APP_VERSION}`,
    date: '2025-05-09', // '09 de Mayo de 2025',
    changes: [
      {
        title: 'Neue mehrsprachige Funktionalität',
        description: [
          'Englisch\', \'Französisch\', \'Deutsch\', \'Katalanisch\', \'Galicisch\' und \'Baskisch\' werden hinzugefügt.',
        ]
      },
      {
        title: 'Änderung der Tagesordnung',
        description: [
          'Die Agenda ändert ihren Namen in \'Gesellschaften\'.',
          'Die Abschnitte \'Verbundene Unternehmen\' und \'Historie\' werden zu Unternehmen hinzugefügt.',
          'Die Abschnitte \'Kontakt-E-Mail\' und \'Bankkonten\' wurden der Zentrale hinzugefügt.',
        ]
      },
      {
        title: 'Neues Schnittstellenmodul für die Rechnungserstellung',
        description: [
          'Für eine korrekte Funktion muss das Modul \'Rechnungsstellung\' aktiviert sein.',
          'Neue Funktion zur Erstellung von Schritt-für-Schritt-Rechnungen hinzugefügt',
          'Die Rechnungserstellungsschritte \'Teilnehmer\', \'Detail\', \'Zeilen\', \'Zahlung\' und \'Anhänge\' werden hinzugefügt.',
          'Die Zusammenfassung der Rechnung wird hinzugefügt.',
        ]
      },
      {
        title: 'Neues Veri*Factu-Modul',
        description: [
          'Veri*Factu-Datensätze werden hinzugefügt.',
          'Es werden die Status \'korrekt\', \'mit Fehlern akzeptiert\', \'fehlerhaft\' und \'ausstehende Meldung\' hinzugefügt.',
          'Datensatzdetails werden hinzugefügt.',
        ]
      },
      {
        title: 'Berichtigung von Fehlern',
        description: [
          'Berichtigung kleinerer Fehler.'
        ]
      },
    ]
  },
  {
    title: 'Version 6.1.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'AAD/SAML2-Authentifizierungskonfiguration',
        description: [
          'Authentifizierungsmodul mit Integration über Azure Active Directory',
          'Authentifizierungsmodul mit Integration durch den SAML2-Standard',
          'Dynamische Anmeldung basierend auf dem Benutzerauthentifizierungstyp'
        ]
      },
      {
        title: 'Neue Webhooks-Module',
        description: [
          'Für die Ereignisse „Rechnungen ausgestellt“ und „Rechnungen erhalten“ werden zwei neue Module hinzugefügt',
          'Eine neue Webhook-Konfigurationsansicht wird hinzugefügt. Integration mit Microsoft Teams oder benutzerdefinierte Integration (Zerocoma)'
        ]
      },
      {
        title: 'Neues TicketBAI-Batuz-Modul',
        description: [
          'Für die Integration mit TicketBAI-Batuz wurde ein Konfigurationsabschnitt hinzugefügt.'
        ]
      },
      {
        title: 'Änderung im Ablauf „Externer Versand“.',
        description: [
          'Der Status „Externer Versand“ wird entfernt.',
          'Rechnungen mit diesem Status erhalten den Status „Gesendet“.',
          'Rechnungen mit der Seite „Externer Versand“ durchlaufen nun den normalen Rechnungsablauf.'
        ]
      },
      {
        title: 'Eliminierung von Aktionen auf ausgestellte Rechnungen',
        description: [
          'Alle „Gehe zu“-Aktionen werden aus Rechnungen mit dem Status „Nicht gesendet“ entfernt.'
        ]
      },
      {
        title: 'Fehlerbehebungen',
        description: [
          'Kleinere Fehlerbehebungen.'
        ]
      },
    ]
  },
  {
    title: 'Version 6.0.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'Neue Agenda-Funktionalität',
        description: [
          'Es wird ein Abschnitt hinzugefügt, in dem Sie verschiedene Arten von Kontakten hinzufügen können.'
        ]
      },
      {
        title: 'Neue Validierungsfunktion',
        description: [
          'Vor dem Hochladen der Rechnung werden die Rechnungsdateien mit ihren Schemata abgeglichen und die Anhänge überprüft.'
        ]
      },
      {
        title: 'Neue Vorlagenfunktion',
        description: [
          'Es wird eine neue Konfiguration mit Standardwerten für die Erstellung neuer Unternehmen und neuer Gruppen hinzugefügt.'
        ]
      },
      {
        title: 'Neues Modul zur Selbstfakturierung',
        description: [
          'Die Option zum Hochladen und Ausstellen von Selbstrechnungen über die Plattform wurde hinzugefügt.'
        ]
      },
      {
        title: 'Neues Gruppierungsmodul',
        description: [
          'Es wird ein Abschnitt hinzugefügt, um Gruppen von Entitäten (Unternehmen, Lieferanten oder Kunden) zu erstellen und diese später in Filtern und anderen Teilen der Anwendung zu verwenden.'
        ]
      },
      {
        title: 'Neues Personalisierungsmodul',
        description: [
          'Es werden verschiedene Anpassungsoptionen hinzugefügt, z. B. Logos, Farben, SMTP-Konto und personalisierte E-Mails.'
        ]
      },
      {
        title: 'Neues PDF-Vorlagenmodul',
        description: [
          'Die Option zum Generieren einer PDF-Rechnung aus der Rechnung wird basierend auf einer festgelegten Vorlage und Konfiguration hinzugefügt.'
        ]
      },
      {
        title: 'Neues Produkt von EdasInvoiZEFiles',
        description: [
          'Die Option zum Hochladen von Rechnungen mit ihren Anhängen aus dem EdasInvoiZEFiles-Dienst wurde hinzugefügt.'
        ]
      },
      {
        title: 'Möglichkeit zum Hochladen erhaltener Rechnungen',
        description: [
          'Im Menü „Rechnungen hochladen“ wurde die Option hinzugefügt, manuell empfangene Rechnungen hochzuladen.'
        ]
      },
      {
        title: 'Filterreorganisation',
        description: [
          'Die Filter der Abschnitte, die sich auf Rechnungen beziehen, wurden neu organisiert.'
        ]
      },
      {
        title: 'Fehlerbehebungen',
        description: [
          'Kleinere Fehlerbehebungen.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.2',
    date: '2024-03-20', // '20 de Marzo de 2024',
    changes: [
      {
        title: '2024-02-06',
        description: [
          'Einige Texte in der Validierung der Lizenzierung wurden korrigiert.'
        ]
      },
      {
        title: 'Fehlerbehebungen',
        description: [
          'Das Verschwinden der Spalte „Detail“ aus den Rechnungstabellen wurde korrigiert.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.1',
    date: '2024-03-18', // '18 de Marzo de 2024',
    changes: [
      {
        title: 'Textaktualisierung',
        description: [
          'Einige Texte innerhalb der Anwendung wurden aktualisiert, um sie besser beschreiben zu können.'
        ]
      },
      {
        title: 'Effizienzsteigerungen',
        description: [
          'Die Effizienz der Selektoren innerhalb der Anwendung wurde verbessert.'
        ]
      },
      {
        title: 'Fehlerbehebungen',
        description: [
          'Kleinere Fehlerbehebungen.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.0',
    date: '2024-02-27', // '27 de Febrero de 2024',
    changes: [
      {
        title: 'Erweiterte Ausgabepläne werden unterstützt',
        description: [
          'Kompatibilität und Validierung anderer Schemata außer Facturae wird hinzugefügt.'
        ]
      },
      {
        title: 'Unterzeichnung und Einziehung von Rechnungen für den externen Versand',
        description: [
          'Der allgemeine Lieferpunkt für den externen Versand wurde hinzugefügt, was nur zum Signieren von Rechnungen nützlich ist, die extern versendet werden sollen.'
        ]
      },
      {
        title: 'Neuer allgemeiner Lieferpunkt Katalonien (e-Fact)',
        description: [
          'Für den Versand von Rechnungen an die Verwaltungen Kataloniens, die nicht FACe-Mitglieder sind, wurde der e-Fact General Delivery Point hinzugefügt.',
          'Konsultieren Sie die teilnehmenden Verwaltungen in #link:eFact#.'
        ],
        links: [
          {
            tag: 'eFact',
            linkName: 'E-Fakt',
            url: 'https://efact.aoc.cat/bustia/receiver/list.htm'
          }
        ]
      },
      {
        title: 'Wiederherstellung gesendeter Dateien',
        description: [
          'Wenn die zu versendende Rechnung für den Versand an den allgemeinen Lieferort geändert wurde, wird sie als mit der Rechnung verknüpftes Dokument gespeichert.'
        ]
      },
      {
        title: 'Unterschrift Dritter',
        description: [
          'Bei allen Rechnungen, die über das Social Collaborator-Zertifikat signiert sind, werden unsere Daten als Dritte im ThirdParty-Knoten der Facturae erfasst.'
        ]
      },
      {
        title: 'Fehlerbehebungen',
        description: [
          'Fehler im Zusammenhang mit vorhandenen Transformatoren.',
          'Kleinere Fehlerbehebungen.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.1.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Neue Funktionen',
        description: [
          'Neue Dashboard-Funktionalität: Neue Ansicht mit nützlichen Informationen zu Rechnungen und Lizenzierung.'
        ]
      },
      {
        title: 'Weitere Änderungen',
        description: [
          'Kleinere Korrekturen.',
        ]
      },
    ]
  },
  {
    title: 'Version 5.0.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'Neue Funktionen',
        description: [
          'Neue Distributor-Funktionalität: Verwalten Sie mehrere Kunden als Distributor mit Lizenzaustausch oder freier Bereitstellung.',
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.2.0',
    date: '2023-10-30', // '30 de Octubre de 2023',
    changes: [
      {
        title: 'Neue Funktionen',
        description: [
          'Neue Gruppenfunktion. Tags sind jetzt Gruppen, Gruppen behalten die Tag-Funktionalität bei und fügen hinzu: Benutzerverwaltung, erweiterte Rechnungsverwaltung.',
          'Aktualisieren des Benutzerprofils mit Informationen zu den Gruppen, denen sie angehören.',
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.1.0',
    date: '2023-08-11', // '11 de Agosto de 2023',
    changes: [
      {
        title: 'Neue Funktionen',
        description: [
          'Einbindung des Rechnungseingangs in die PGE FACe und FACeB2B.',
          'Neue Module zur Miete verfügbar. Sie können sie im Abschnitt „Allgemeine Einstellungen“ überprüfen.'
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.0.0',
    date: '2023-05-24', // '24 de Mayo de 2023',
    changes: [
      {
        title: 'Start',
        description: [
          // 'Management und Verwaltung von...',
        ]
      },
    ]
  }, 
  // {
  //   title: 'Version 2.11.0',
  //   date: '2022-12-13', // '13 de Diciembre de 2022',
  //   changes: [
  //     {
  //       title: 'Neue Funktionen',
  //       description: [
  //         'Neuer Benutzertyp: Abfragebenutzer. Benutzer zur Datenabfrage und -prüfung, ähnlich der Rolle „Benutzer“, mit Einschränkungen bei der Durchführung von Aktionen an Rechnungen, Sie können diese nur anzeigen und ihren Inhalt herunterladen.',
  //         'Neue Funktionalität zum Bearbeiten und Löschen zusätzlicher Metadaten aus einer Rechnung, zugänglich in den Rechnungsdetails.',
  //         'Die Option zum Exportieren einer Excel-Datei mit erkannten Fehlern wurde zum Dialogfeld „Dashboard-Fehlerdetails“ hinzugefügt.',
  //         'Es wurde eine neue Option hinzugefügt, um aus dem Fehlerdetails-Dialogfeld des Dashboards eine Excel-Datei mit dem vollständigen Verlauf der erkannten Fehler für ein bestimmtes Unternehmen und einen bestimmten Hauptsitz zu exportieren.',
  //         'Bei Auswahl der Aktion „Zugehörige Organisation ausschließen“ aus der Rechnungsansicht wurde die Option hinzugefügt, diese Organisation von allen Unternehmen des Kunden auszuschließen, zusätzlich zur Beibehaltung der Standardoption, nur die Organisation von dem mit dieser Rechnung verknüpften Unternehmen auszuschließen.',
  //       ]
  //     },
  //     {
  //       title: 'Fehler behoben',
  //       description: [
  //         'Fehler beim manuellen Hochladen von Rechnungen behoben.',
  //         'Korrekturen in Texten und Beschreibungen.',
  //         'Weitere kleinere Korrekturen',
  //       ]
  //     },
  //   ]
  // }, 
]

export {
  PATCH_NOTES
}

